import React from 'react';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import CustomButton from 'helperComponents/CustomButton';

const FileTypePopup = ({ loading, setShowFileTypePopup, downloadData, fileType, setFileType, onlySequences, setOnlySequences, overlayZIndex, showHighlightsOnly = true }) => {
   const { t } = useTranslation();

   const handleChange = (e) => {
      setFileType(e.target.value)
   }

   const handleOnlySequencesChange = (e) => {
      setOnlySequences(e.target.checked)
   }

   return (
      <div
         className={styles.fileTypeModal}
         style={overlayZIndex ? { zIndex: overlayZIndex } : undefined}
      >
         <div className={styles.centerWrapper}>
            <div className={styles.contentBox}>
               <p className={styles.title}>{t("common.exportReviews")}</p>
               <div className={styles.optionsContainer}>
                  {showHighlightsOnly ? (
                  <div className={styles.optionSection}>
                     <div className={styles.checkboxInput}>
                        <div className={styles.item}>
                           <input 
                              onChange={handleOnlySequencesChange} 
                              type="checkbox" 
                              id="onlySequences" 
                              checked={onlySequences} 
                              name="only-sequences" 
                           />
                           <label htmlFor="onlySequences">{t("common.highlightsOnly")}</label>
                        </div>
                     </div>
                  </div>
                  ) : null}
                  <div className={styles.optionSection}>
                     <p className={styles.subtitle}>File Format</p>
                     <div className={styles.radioInput}>
                        <div className={styles.item}>
                           <input onChange={handleChange} type="radio" id="xlsx" value={"xlsx"} checked={fileType === 'xlsx'} name="file-type" />
                           <label htmlFor="xlsx">XLSX</label>
                        </div>
                        <div className={styles.item}>
                           <input onChange={handleChange} type="radio" checked={fileType === 'csv'} value="csv" id="csv" name="file-type" />
                           <label htmlFor="csv">CSV</label>
                        </div>
                     </div>
                  </div>
               </div>
               <div className={styles.btnBlock}>
                  <button className={styles.underlineBtn} onClick={() => setShowFileTypePopup(false)}>{t("button.3")}</button>
                  <CustomButton onClick={downloadData} text={t("common.export")} loading={loading} />
               </div>
            </div>
         </div>
      </div>
   )
}

export default FileTypePopup;